<div class="tab-header">
    <div class="tab active">
        <h1>Ofte stilte spørsmål</h1>
    </div>
</div>
<mat-accordion>

    <mat-expansion-panel *ngFor="let question of faqQuestions">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{question.Properties[0]?.Value}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <p [innerHtml]="question.Properties[1]?.Value"></p>
    </mat-expansion-panel>
</mat-accordion>
